module.exports = __webpack_public_path__ + "static/media/image 37.0752c4fa.png";